import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import StatusContext from '../../../contexts/StatusContext'
import CommonTasksContext from '../../../contexts/CommonTasksContext'
import { PushButton } from '../pushbutton/PushButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {ScrollText} from "../scrolltext/ScrollText"
import { useState, useRef, useEffect } from "react";

export const DialogCustomPrompt = () => {

  const [status, setStatus] = useState('')
  
  const {
    changeLanguage,
} = React.useContext(StatusContext);

const {
  setShowCustomPromptDialog,
  showcustompromptdialog,
  setCustomPrompt,
  customprompt,
  onSaveCustomPrompts,
  promptNameExists,
  addpromptmode,
  setShowSaveDialog,

} = React.useContext(CommonTasksContext);

const promptAreaRef = useRef(null);

  useEffect(() => {

    if (promptAreaRef.current) {
      promptAreaRef.current.style.height = 'auto';
      promptAreaRef.current.style.height = `${promptAreaRef.current.scrollHeight}px`;
  }
}, [promptAreaRef]);


const handleChangeName = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
  let a = {
    id:customprompt.id, 
    default: false,
    name: event.target.value,
    prompt: customprompt.prompt,
  }
  setCustomPrompt(a)
};

const handleChangePrompt = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
  let a = {
    id:customprompt.id, 
    default: false,
    name: customprompt.name,
    prompt: event.target.value,
  }
  setCustomPrompt(a)
};


const handleSave = async (e) => {

  console.log("handleSave")
  if (addpromptmode)
  {
    if (promptNameExists())
    {
      setStatus(changeLanguage("common", "dialogsamename"))
      return
    }
    else
    {
      onSaveCustomPrompts()
    }
  
    handleClose()
    
  }

  if (!addpromptmode)
    setShowSaveDialog(true)

}

const handleClose = () => {
  setStatus('')
  setShowCustomPromptDialog(false);
};

  return (
   
    <React.Fragment>
   
        <Dialog
          open={showcustompromptdialog}
        
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
            
            },
          }}
        >

        <DialogTitle>{changeLanguage('common', 'dialogtitle')}</DialogTitle>

        <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
       <CloseIcon />
      </IconButton>

      <DialogTitle style={{color: 'rgb(138, 57, 57)', marginBottom:'-15px'}}>{addpromptmode ? changeLanguage('common', 'dialogaddprompt') : changeLanguage('common', 'dialogeditprompt')}</DialogTitle>
       
        <DialogContent dividers>
          <div>
              <label style={{fontSize:'12px'}}>{changeLanguage('common', 'dialoglabel_1')}</label>
              <ScrollText text={customprompt.name} onChange={handleChangeName} />
              <br></br>

              <label style={{fontSize:'12px'}}>{changeLanguage('common', 'dialoglabel_2')}</label>
              <ScrollText text={customprompt.prompt} onChange={handleChangePrompt}/>
              <br></br>

              <PushButton label={addpromptmode ? changeLanguage('common','dialogadd') :  changeLanguage('common','dialogupdate')} disablebutton = {customprompt.name.length === 0 || customprompt.prompt.length === 0} onClick={handleSave}/>
              <br></br>
              <br></br>
              {
                (status) && <label>{status}</label>
              }
          </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
    
  );
  
}